import React from 'react';
import { Form, Card } from 'react-bootstrap';
import Api from '../../../../../services/ApiService';
import ModeComponent from '../../ModeComponent';
import PartsRequestCollection from '../../PartsRequestCollection';

export default class PartsRequest extends ModeComponent {
  // properties set on each mount
  clockType = 'mechanics';
  defaultFocus = 'roInput';
  mode = 'PR';
  prCollection = null;

  schema = {
    roInput: {
      errorText: 'Valid RO Required',
      label: 'Repair Order',
      required: true,
    },
  };

  // The parts request collection maintains its own state, which can
  // be retrieved via <PartsRequestCollection>.get()
  state = {
    roInput: {
      value: '',
      validationState: null,
    },
  };
  // end properties reset on each mount

  process(userID, password) {
    if (this.validateForm() && this.prCollection.validate()) {
      // run D3/QM command here (see timeclock.controller.js:processAction())
      const { op: opInput, qty: partQtyInput, txt: partTextInput } = this.prCollection.get();
      const postBody = {
        clockType: this.clockType,
        mode: this.mode,
        params: {
          opInput,
          partQtyInput,
          partTextInput,
          roInput: this.state.roInput.value,
        },
        userID,
        password,
      };

      return new Promise((resolve, reject) => {
        Api.post('timeclock/processaction', postBody)
          .then(res => {
            res = res.data;
            if (res.d3status === 'OK') {
              resolve(res.d3message); // optional additional success info as a param
            } else {
              throw new Error(res.d3message);
            }
          })
          .catch(error => {
            reject(error.message);
          });
      });
    }

    // prevents process / reset if form is invalid (add string to pop toaster)
    // in the case of PartRequest, this code hits if Repair Order is empty
    return Promise.reject('');
  }

  render() {
    return (
      <Card className="success">
        <Card.Header>
          <Card.Title>Action Details</Card.Title>
        </Card.Header>
        <Card.Body>
          <Form
            onSubmit={e => {
              e.preventDefault();
            }}
          >
            {this.validatedROInput('roInput')}
          </Form>
          <PartsRequestCollection
            ref={ref => {
              this.prCollection = ref;
            }}
          />
        </Card.Body>
      </Card>
    );
  }
}
